import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../header/Header";
import { Footer } from "../Footer";
import enterpriseAiImg from "../../assets/RPA/enterprise-ai.png";
import loanOriginationImg from "../../assets/RPA/loan-origination.png";

const AgenticSolutions = () => {
  const navigate = useNavigate();

  const industries = [
    {
      title: "Banking",
      desc: "Secure transaction processing and automated risk assessment.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M4.5 24V13.5H7.5V24H4.5ZM13.5 24V13.5H16.5V24H13.5ZM0 30V27H30V30H0ZM22.5 24V13.5H25.5V24H22.5ZM0 10.5V7.5L15 0L30 7.5V10.5H0ZM6.675 7.5H15H23.325H6.675ZM6.675 7.5H23.325L15 3.375L6.675 7.5Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "Customer Experience",
      desc: "Empathetic AI agents providing 24/7 hyper-personalized support.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M15 23.25C16.7 23.25 18.2437 22.7687 19.6313 21.8062C21.0188 20.8438 22.025 19.575 22.65 18H7.35C7.975 19.575 8.98125 20.8438 10.3687 21.8062C11.7562 22.7687 13.3 23.25 15 23.25ZM8.7 13.5L10.35 11.925L11.925 13.5L13.5 11.925L10.35 8.7L7.125 11.925L8.7 13.5ZM18.075 13.5L19.65 11.925L21.3 13.5L22.875 11.925L19.65 8.7L16.5 11.925L18.075 13.5ZM15 30C12.925 30 10.975 29.6063 9.15 28.8188C7.325 28.0312 5.7375 26.9625 4.3875 25.6125C3.0375 24.2625 1.96875 22.675 1.18125 20.85C0.39375 19.025 0 17.075 0 15C0 12.925 0.39375 10.975 1.18125 9.15C1.96875 7.325 3.0375 5.7375 4.3875 4.3875C5.7375 3.0375 7.325 1.96875 9.15 1.18125C10.975 0.39375 12.925 0 15 0C17.075 0 19.025 0.39375 20.85 1.18125C22.675 1.96875 24.2625 3.0375 25.6125 4.3875C26.9625 5.7375 28.0312 7.325 28.8188 9.15C29.6063 10.975 30 12.925 30 15C30 17.075 29.6063 19.025 28.8188 20.85C28.0312 22.675 26.9625 24.2625 25.6125 25.6125C24.2625 26.9625 22.675 28.0312 20.85 28.8188C19.025 29.6063 17.075 30 15 30ZM15 27C18.35 27 21.1875 25.8375 23.5125 23.5125C25.8375 21.1875 27 18.35 27 15C27 11.65 25.8375 8.8125 23.5125 6.4875C21.1875 4.1625 18.35 3 15 3C11.65 3 8.8125 4.1625 6.4875 6.4875C4.1625 8.8125 3 11.65 3 15C3 18.35 4.1625 21.1875 6.4875 23.5125C8.8125 25.8375 11.65 27 15 27Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "Cybersecurity",
      desc: "Predictive threat detection and automated incident response.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="30"
          viewBox="0 0 24 30"
          fill="none"
        >
          <path
            d="M12 30C8.525 29.125 5.65625 27.1312 3.39375 24.0187C1.13125 20.9062 0 17.45 0 13.65V4.5L12 0L24 4.5V13.65C24 17.45 22.8688 20.9062 20.6063 24.0187C18.3438 27.1312 15.475 29.125 12 30ZM12 26.85C14.6 26.025 16.75 24.375 18.45 21.9C20.15 19.425 21 16.675 21 13.65V6.5625L12 3.1875L3 6.5625V13.65C3 16.675 3.85 19.425 5.55 21.9C7.25 24.375 9.4 26.025 12 26.85ZM9 21H15C15.425 21 15.7812 20.8563 16.0688 20.5688C16.3563 20.2812 16.5 19.925 16.5 19.5V15C16.5 14.575 16.3563 14.2188 16.0688 13.9312C15.7812 13.6437 15.425 13.5 15 13.5V12C15 11.175 14.7062 10.4688 14.1187 9.88125C13.5312 9.29375 12.825 9 12 9C11.175 9 10.4688 9.29375 9.88125 9.88125C9.29375 10.4688 9 11.175 9 12V13.5C8.575 13.5 8.21875 13.6437 7.93125 13.9312C7.64375 14.2188 7.5 14.575 7.5 15V19.5C7.5 19.925 7.64375 20.2812 7.93125 20.5688C8.21875 20.8563 8.575 21 9 21ZM10.5 13.5V12C10.5 11.575 10.6437 11.2188 10.9312 10.9312C11.2188 10.6437 11.575 10.5 12 10.5C12.425 10.5 12.7812 10.6437 13.0688 10.9312C13.3563 11.2188 13.5 11.575 13.5 12V13.5H10.5Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "Healthcare",
      desc: "HIPAA-compliant data analysis and patient care optimization.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M3 30C2.175 30 1.46875 29.7062 0.88125 29.1187C0.29375 28.5312 0 27.825 0 27V9C0 8.175 0.29375 7.46875 0.88125 6.88125C1.46875 6.29375 2.175 6 3 6H9V3C9 2.175 9.29375 1.46875 9.88125 0.88125C10.4688 0.29375 11.175 0 12 0H18C18.825 0 19.5312 0.29375 20.1187 0.88125C20.7062 1.46875 21 2.175 21 3V6H27C27.825 6 28.5312 6.29375 29.1187 6.88125C29.7062 7.46875 30 8.175 30 9V27C30 27.825 29.7062 28.5312 29.1187 29.1187C28.5312 29.7062 27.825 30 27 30H3ZM3 27H27V9H3V27ZM12 6H18V3H12V6ZM3 27V9V27ZM13.5 19.5V24H16.5V19.5H21V16.5H16.5V12H13.5V16.5H9V19.5H13.5Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "High Tech",
      desc: "Accelerating software development and infrastructure management.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
        >
          <path
            d="M9 18V9H18V18H9ZM12 15H15V12H12V15ZM9 27V24H6C5.175 24 4.46875 23.7062 3.88125 23.1187C3.29375 22.5312 3 21.825 3 21V18H0V15H3V12H0V9H3V6C3 5.175 3.29375 4.46875 3.88125 3.88125C4.46875 3.29375 5.175 3 6 3H9V0H12V3H15V0H18V3H21C21.825 3 22.5312 3.29375 23.1187 3.88125C23.7062 4.46875 24 5.175 24 6V9H27V12H24V15H27V18H24V21C24 21.825 23.7062 22.5312 23.1187 23.1187C22.5312 23.7062 21.825 24 21 24H18V27H15V24H12V27H9ZM21 21V6H6V21H21Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "Insurance",
      desc: "Claims processing automation and underwriting accuracy.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="30"
          viewBox="0 0 24 30"
          fill="none"
        >
          <path
            d="M12 30C8.525 29.125 5.65625 27.1312 3.39375 24.0187C1.13125 20.9062 0 17.45 0 13.65V4.5L12 0L24 4.5V13.65C24 15.775 23.6375 17.8188 22.9125 19.7812C22.1875 21.7437 21.15 23.475 19.8 24.975L15 20.175C14.55 20.45 14.0687 20.6562 13.5562 20.7938C13.0437 20.9313 12.525 21 12 21C10.35 21 8.9375 20.4125 7.7625 19.2375C6.5875 18.0625 6 16.65 6 15C6 13.35 6.5875 11.9375 7.7625 10.7625C8.9375 9.5875 10.35 9 12 9C13.65 9 15.0625 9.5875 16.2375 10.7625C17.4125 11.9375 18 13.35 18 15C18 15.55 17.9313 16.0812 17.7938 16.5938C17.6562 17.1063 17.45 17.6 17.175 18.075L19.425 20.325C19.925 19.3 20.3125 18.225 20.5875 17.1C20.8625 15.975 21 14.825 21 13.65V6.5625L12 3.1875L3 6.5625V13.65C3 16.675 3.85 19.425 5.55 21.9C7.25 24.375 9.4 26.025 12 26.85C12.65 26.65 13.2688 26.3937 13.8562 26.0812C14.4437 25.7687 15.025 25.4 15.6 24.975L17.7 27.075C16.875 27.75 15.9812 28.3375 15.0188 28.8375C14.0563 29.3375 13.05 29.725 12 30ZM12 18C12.825 18 13.5312 17.7062 14.1187 17.1187C14.7062 16.5312 15 15.825 15 15C15 14.175 14.7062 13.4688 14.1187 12.8813C13.5312 12.2938 12.825 12 12 12C11.175 12 10.4688 12.2938 9.88125 12.8813C9.29375 13.4688 9 14.175 9 15C9 15.825 9.29375 16.5312 9.88125 17.1187C10.4688 17.7062 11.175 18 12 18Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "Manufacturing",
      desc: "Digital twin integration and smart supply line management.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M1.5 27.7588V23.2588H6.15L2.325 10.7338C1.65 10.3588 1.09375 9.80882 0.65625 9.08382C0.21875 8.35882 0 7.58382 0 6.75882C0 5.50882 0.4375 4.44632 1.3125 3.57132C2.1875 2.69632 3.25 2.25882 4.5 2.25882C5.475 2.25882 6.34375 2.54007 7.10625 3.10257C7.86875 3.66507 8.4 4.38382 8.7 5.25882H13.5V3.75882C13.5 3.33382 13.6437 2.97757 13.9312 2.69007C14.2188 2.40257 14.575 2.25882 15 2.25882C15.225 2.25882 15.4438 2.30882 15.6562 2.40882C15.8687 2.50882 16.05 2.65882 16.2 2.85882L18.75 0.458824C18.975 0.233824 19.2437 0.0900735 19.5562 0.0275735C19.8687 -0.0349265 20.175 0.00882353 20.475 0.158824L26.325 2.85882C26.625 3.00882 26.8313 3.22757 26.9438 3.51507C27.0562 3.80257 27.05 4.08382 26.925 4.35882C26.775 4.65882 26.5562 4.85257 26.2687 4.94007C25.9812 5.02757 25.7 5.00882 25.425 4.88382L20.025 2.40882L16.5 5.70882V7.80882L20.025 11.0338L25.425 8.55882C25.7 8.43382 25.9875 8.42132 26.2875 8.52132C26.5875 8.62132 26.8 8.80882 26.925 9.08382C27.075 9.38382 27.0875 9.67132 26.9625 9.94632C26.8375 10.2213 26.625 10.4338 26.325 10.5838L20.475 13.3588C20.175 13.5088 19.8687 13.5526 19.5562 13.4901C19.2437 13.4276 18.975 13.2838 18.75 13.0588L16.2 10.6588C16.05 10.8088 15.8687 10.9463 15.6562 11.0713C15.4438 11.1963 15.225 11.2588 15 11.2588C14.575 11.2588 14.2188 11.1151 13.9312 10.8276C13.6437 10.5401 13.5 10.1838 13.5 9.75882V8.25882H8.7C8.625 8.45882 8.54375 8.64632 8.45625 8.82132C8.36875 8.99632 8.25 9.18382 8.1 9.38382L15.6 23.2588H21V27.7588H1.5ZM4.5 8.25882C4.925 8.25882 5.28125 8.11507 5.56875 7.82757C5.85625 7.54007 6 7.18382 6 6.75882C6 6.33382 5.85625 5.97757 5.56875 5.69007C5.28125 5.40257 4.925 5.25882 4.5 5.25882C4.075 5.25882 3.71875 5.40257 3.43125 5.69007C3.14375 5.97757 3 6.33382 3 6.75882C3 7.18382 3.14375 7.54007 3.43125 7.82757C3.71875 8.11507 4.075 8.25882 4.5 8.25882ZM9.225 23.2588H12.15L5.7 11.2588C5.7 11.2588 5.675 11.2588 5.625 11.2588C5.575 11.2588 5.55 11.2588 5.55 11.2588L9.225 23.2588Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
    {
      title: "Retail",
      desc: "Omnichannel inventory and dynamic demand forecasting.",
      iconPath: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="30"
          viewBox="0 0 24 30"
          fill="none"
        >
          <path
            d="M3 30C2.175 30 1.46875 29.7062 0.88125 29.1187C0.29375 28.5312 0 27.825 0 27V9C0 8.175 0.29375 7.46875 0.88125 6.88125C1.46875 6.29375 2.175 6 3 6H6C6 4.35 6.5875 2.9375 7.7625 1.7625C8.9375 0.5875 10.35 0 12 0C13.65 0 15.0625 0.5875 16.2375 1.7625C17.4125 2.9375 18 4.35 18 6H21C21.825 6 22.5312 6.29375 23.1187 6.88125C23.7062 7.46875 24 8.175 24 9V27C24 27.825 23.7062 28.5312 23.1187 29.1187C22.5312 29.7062 21.825 30 21 30H3ZM3 27H21V9H18V12C18 12.425 17.8563 12.7812 17.5688 13.0688C17.2812 13.3563 16.925 13.5 16.5 13.5C16.075 13.5 15.7188 13.3563 15.4312 13.0688C15.1437 12.7812 15 12.425 15 12V9H9V12C9 12.425 8.85625 12.7812 8.56875 13.0688C8.28125 13.3563 7.925 13.5 7.5 13.5C7.075 13.5 6.71875 13.3563 6.43125 13.0688C6.14375 12.7812 6 12.425 6 12V9H3V27ZM9 6H15C15 5.175 14.7062 4.46875 14.1187 3.88125C13.5312 3.29375 12.825 3 12 3C11.175 3 10.4688 3.29375 9.88125 3.88125C9.29375 4.46875 9 5.175 9 6ZM3 27V9V27Z"
            fill="#00450D"
          />
        </svg>
      ),
    },
  ];

  const departments = [
    {
      title: "IT",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
        >
          <path
            d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM2 14H18V4H2V14ZM5.5 13L4.1 11.6L6.675 9L4.075 6.4L5.5 5L9.5 9L5.5 13ZM10 13V11H16V13H10Z"
            fill="#00450D"
          />
        </svg>
      ),
      items: ["Auto-remediation of cloud outages", "Legacy code modernization"],
    },
    {
      title: "Finance",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="16"
          viewBox="0 0 22 16"
          fill="none"
        >
          <path
            d="M13 9C12.1667 9 11.4583 8.70833 10.875 8.125C10.2917 7.54167 10 6.83333 10 6C10 5.16667 10.2917 4.45833 10.875 3.875C11.4583 3.29167 12.1667 3 13 3C13.8333 3 14.5417 3.29167 15.125 3.875C15.7083 4.45833 16 5.16667 16 6C16 6.83333 15.7083 7.54167 15.125 8.125C14.5417 8.70833 13.8333 9 13 9ZM6 12C5.45 12 4.97917 11.8042 4.5875 11.4125C4.19583 11.0208 4 10.55 4 10V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H20C20.55 0 21.0208 0.195833 21.4125 0.5875C21.8042 0.979167 22 1.45 22 2V10C22 10.55 21.8042 11.0208 21.4125 11.4125C21.0208 11.8042 20.55 12 20 12H6ZM8 10H18C18 9.45 18.1958 8.97917 18.5875 8.5875C18.9792 8.19583 19.45 8 20 8V4C19.45 4 18.9792 3.80417 18.5875 3.4125C18.1958 3.02083 18 2.55 18 2H8C8 2.55 7.80417 3.02083 7.4125 3.4125C7.02083 3.80417 6.55 4 6 4V8C6.55 8 7.02083 8.19583 7.4125 8.5875C7.80417 8.97917 8 9.45 8 10ZM19 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V3H2V14H19V16ZM6 10V2V10Z"
            fill="#00450D"
          />
        </svg>
      ),
      items: [
        "Automated AP/AR reconciliation",
        "Real-time cash flow forecasting",
      ],
    },
    {
      title: "HR",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="12"
          viewBox="0 0 24 12"
          fill="none"
        >
          <path
            d="M0 12V10.425C0 9.70833 0.366667 9.125 1.1 8.675C1.83333 8.225 2.8 8 4 8C4.21667 8 4.425 8.00417 4.625 8.0125C4.825 8.02083 5.01667 8.04167 5.2 8.075C4.96667 8.425 4.79167 8.79167 4.675 9.175C4.55833 9.55833 4.5 9.95833 4.5 10.375V12H0ZM6 12V10.375C6 9.84167 6.14583 9.35417 6.4375 8.9125C6.72917 8.47083 7.14167 8.08333 7.675 7.75C8.20833 7.41667 8.84583 7.16667 9.5875 7C10.3292 6.83333 11.1333 6.75 12 6.75C12.8833 6.75 13.6958 6.83333 14.4375 7C15.1792 7.16667 15.8167 7.41667 16.35 7.75C16.8833 8.08333 17.2917 8.47083 17.575 8.9125C17.8583 9.35417 18 9.84167 18 10.375V12H6ZM19.5 12V10.375C19.5 9.94167 19.4458 9.53333 19.3375 9.15C19.2292 8.76667 19.0667 8.40833 18.85 8.075C19.0333 8.04167 19.2208 8.02083 19.4125 8.0125C19.6042 8.00417 19.8 8 20 8C21.2 8 22.1667 8.22083 22.9 8.6625C23.6333 9.10417 24 9.69167 24 10.425V12H19.5ZM8.125 10H15.9C15.7333 9.66667 15.2708 9.375 14.5125 9.125C13.7542 8.875 12.9167 8.75 12 8.75C11.0833 8.75 10.2458 8.875 9.4875 9.125C8.72917 9.375 8.275 9.66667 8.125 10ZM4 7C3.45 7 2.97917 6.80417 2.5875 6.4125C2.19583 6.02083 2 5.55 2 5C2 4.43333 2.19583 3.95833 2.5875 3.575C2.97917 3.19167 3.45 3 4 3C4.56667 3 5.04167 3.19167 5.425 3.575C5.80833 3.95833 6 4.43333 6 5C6 5.55 5.80833 6.02083 5.425 6.4125C5.04167 6.80417 4.56667 7 4 7ZM20 7C19.45 7 18.9792 6.80417 18.5875 6.4125C18.1958 6.02083 18 5.55 18 5C18 4.43333 18.1958 3.95833 18.5875 3.575C18.9792 3.19167 19.45 3 20 3C20.5667 3 21.0417 3.19167 21.425 3.575C21.8083 3.95833 22 4.43333 22 5C22 5.55 21.8083 6.02083 21.425 6.4125C21.0417 6.80417 20.5667 7 20 7ZM12 6C11.1667 6 10.4583 5.70833 9.875 5.125C9.29167 4.54167 9 3.83333 9 3C9 2.15 9.29167 1.4375 9.875 0.8625C10.4583 0.2875 11.1667 0 12 0C12.85 0 13.5625 0.2875 14.1375 0.8625C14.7125 1.4375 15 2.15 15 3C15 3.83333 14.7125 4.54167 14.1375 5.125C13.5625 5.70833 12.85 6 12 6ZM12 4C12.2833 4 12.5208 3.90417 12.7125 3.7125C12.9042 3.52083 13 3.28333 13 3C13 2.71667 12.9042 2.47917 12.7125 2.2875C12.5208 2.09583 12.2833 2 12 2C11.7167 2 11.4792 2.09583 11.2875 2.2875C11.0958 2.47917 11 2.71667 11 3C11 3.28333 11.0958 3.52083 11.2875 3.7125C11.4792 3.90417 11.7167 4 12 4Z"
            fill="#00450D"
          />
        </svg>
      ),
      items: [
        "Talent matching & skills gap analysis",
        "Automated employee onboarding flows",
      ],
    },
    {
      title: "Supply Chain",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="16"
          viewBox="0 0 22 16"
          fill="none"
        >
          <path
            d="M5 16C4.16667 16 3.45833 15.7083 2.875 15.125C2.29167 14.5417 2 13.8333 2 13H0V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16V4H19L22 8V13H20C20 13.8333 19.7083 14.5417 19.125 15.125C18.5417 15.7083 17.8333 16 17 16C16.1667 16 15.4583 15.7083 14.875 15.125C14.2917 14.5417 14 13.8333 14 13H8C8 13.8333 7.70833 14.5417 7.125 15.125C6.54167 15.7083 5.83333 16 5 16ZM5 14C5.28333 14 5.52083 13.9042 5.7125 13.7125C5.90417 13.5208 6 13.2833 6 13C6 12.7167 5.90417 12.4792 5.7125 12.2875C5.52083 12.0958 5.28333 12 5 12C4.71667 12 4.47917 12.0958 4.2875 12.2875C4.09583 12.4792 4 12.7167 4 13C4 13.2833 4.09583 13.5208 4.2875 13.7125C4.47917 13.9042 4.71667 14 5 14ZM2 11H2.8C3.08333 10.7 3.40833 10.4583 3.775 10.275C4.14167 10.0917 4.55 10 5 10C5.45 10 5.85833 10.0917 6.225 10.275C6.59167 10.4583 6.91667 10.7 7.2 11H14V2H2V11ZM17 14C17.2833 14 17.5208 13.9042 17.7125 13.7125C17.9042 13.5208 18 13.2833 18 13C18 12.7167 17.9042 12.4792 17.7125 12.2875C17.5208 12.0958 17.2833 12 17 12C16.7167 12 16.4792 12.0958 16.2875 12.2875C16.0958 12.4792 16 12.7167 16 13C16 13.2833 16.0958 13.5208 16.2875 13.7125C16.4792 13.9042 16.7167 14 17 14ZM16 9H20.25L18 6H16V9Z"
            fill="#00450D"
          />
        </svg>
      ),
      items: ["Logistic route optimization", "Supplier risk mitigation"],
    },
    {
      title: "Contact Center",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
        >
          <path
            d="M9 21V19H16V18H12V10H16V9C16 7.06667 15.3167 5.41667 13.95 4.05C12.5833 2.68333 10.9333 2 9 2C7.06667 2 5.41667 2.68333 4.05 4.05C2.68333 5.41667 2 7.06667 2 9V10H6V18H2C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V9C0 7.76667 0.2375 6.60417 0.7125 5.5125C1.1875 4.42083 1.83333 3.46667 2.65 2.65C3.46667 1.83333 4.42083 1.1875 5.5125 0.7125C6.60417 0.2375 7.76667 0 9 0C10.2333 0 11.3958 0.2375 12.4875 0.7125C13.5792 1.1875 14.5333 1.83333 15.35 2.65C16.1667 3.46667 16.8125 4.42083 17.2875 5.5125C17.7625 6.60417 18 7.76667 18 9V19C18 19.55 17.8042 20.0208 17.4125 20.4125C17.0208 20.8042 16.55 21 16 21H9ZM2 16H4V12H2V16ZM14 16H16V12H14V16ZM2 12H4H2ZM14 12H16H14Z"
            fill="#00450D"
          />
        </svg>
      ),
      items: ["Real-time agent assist", "Voice-to-action automation"],
    },
    {
      title: "Legal",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
        >
          <path
            d="M0 19V17H12V19H0ZM5.65 14.15L0 8.5L2.1 6.35L7.8 12L5.65 14.15ZM12 7.8L6.35 2.1L8.5 0L14.15 5.65L12 7.8ZM16.6 18L3.55 4.95L4.95 3.55L18 16.6L16.6 18Z"
            fill="#00450D"
          />
        </svg>
      ),
      items: ["Contract lifecycle management", "Regulatory change monitoring"],
    },
  ];

  return (
    <div className="fixed inset-0 w-screen h-screen flex flex-col overflow-hidden bg-white">
      <Header />
      <div className="w-full h-full overflow-y-auto overflow-x-hidden font-sans">
        {/* Hero Section */}
        <section className="relative bg-[#00450d] py-20 px-6 overflow-hidden">
          {/* Subtle Gradient Background */}
          <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_top_right,_#1b5e20,_transparent),_radial-gradient(circle_at_bottom_left,_#00450d,_transparent)]"></div>

          <div className="max-w-[1536px] w-full grid grid-cols-1 ipadMax:grid-cols-2 laptop:grid-cols-2 largeScreen:grid-cols-2 gap-12 relative z-10 place-items-center">
            <div className="flex flex-col gap-8">
              <div className="bg-[#1b5e20] w-fit px-4 py-1.5 rounded-full border border-green-700/30">
                <span className="text-[#90d689] text-sm font-semibold tracking-[1.4px] uppercase">
                  Agentic Excellence
                </span>
              </div>

              <h1 className="text-5xl md:text-6xl lg:text-[72px] font-extrabold text-white leading-[1.1] tracking-[-2px] manrope">
                Agentic solutions for <br className="hidden md:block" />
                your industry and <br className="hidden md:block" />
                departments
              </h1>

              <p className="text-[#acf4a4] text-lg md:text-xl max-w-[580px] leading-relaxed">
                Teja Technologies deploys specialized AI agents designed to
                handle complex orchestration, decision-making, and high-trust
                enterprise workflows.
              </p>

              {/* <div className="flex flex-wrap gap-4 pt-4">
                <button className="bg-[#f6e550] text-[#1f1c00] px-8 py-4 rounded-full font-bold text-lg hover:bg-[#ffe500] transition-all transform hover:scale-105">
                  Explore Ecosystem
                </button>
                <button className="border border-white/20 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white/10 transition-all flex items-center gap-2">
                  Watch Vision
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
                </button>
              </div> */}
            </div>

            <div className="relative group ipadMin:hidden">
              <div className="absolute -inset-4 bg-[#f6e550]/20 blur-[40px] rounded-[48px] opacity-50 group-hover:opacity-75 transition-opacity"></div>
              <div className="relative rounded-[32px] overflow-hidden border border-white/10 shadow-2xl bg-white/5 backdrop-blur-sm  aspect-auto h-[400px]">
                <img
                  src={enterpriseAiImg}
                  alt="Enterprise AI Visualization"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
                />
              </div>
            </div>
          </div>
        </section>

        {/* By Industry Section */}
        <section className="bg-[#f5fced] py-14 px-6">
          <div className="max-w-[1536px] mx-auto flex flex-col gap-16">
            <div className="flex flex-col gap-4">
              <h2 className="text-4xl md:text-[48px] font-bold text-[#171d14] tracking-[-1.2px] manrope">
                By Industry
              </h2>
              <p className="text-[#41493e] text-lg max-w-2xl leading-relaxed">
                Purpose-built AI architectures designed for the unique
                regulatory and operational needs of your sector.
              </p>
            </div>

            <div className="grid grid-cols-4 mobile:grid-cols-1 mobile:gap-4 ipadMin:grid-cols-2 ipadMin:gap-4 ipadMax:gap-4 gap-8">
              {industries.map((ind, i) => (
                <div
                  key={i}
                  className="bg-[#eff6e7] p-8 mobile:p-4 ipadMin:p-3 ipadMax:p-3 rounded-[32px] hover:shadow-xl hover:scale-[1.02] transition-all duration-300 flex flex-col gap-6 group"
                >
                  <div className="bg-white/50 p-3 rounded-2xl w-fit group-hover:bg-white transition-colors">
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="text-[#00450d]"
                    >
                      <path d={ind.iconPath} />
                    </svg> */}
                    {ind.iconPath}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#171d14] mb-2">
                      {ind.title}
                    </h3>
                    <p className="text-[#41493e] text-sm leading-[1.6]">
                      {ind.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* By Department Section */}
        <section className="bg-[#eff6e7] py-24 px-6">
          <div className="max-w-[1536px] mx-auto flex flex-col gap-16">
            <div className="flex flex-col gap-4 text-right items-end">
              <h2 className="text-4xl md:text-[48px] font-bold text-[#171d14] tracking-[-1.2px] manrope">
                By Department
              </h2>
              <p className="text-[#41493e] text-lg max-w-2xl leading-relaxed">
                Transforming internal functions from cost centers into growth
                engines with specialized AI workforce.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-8 mobile:grid-cols-1 mobile:gap-4 ipadMin:grid-cols-2 ipadMin:gap-4 ipadMax:gap-4">
              {departments.map((dept, i) => (
                <div
                  key={i}
                  className="bg-white border-l-4 border-[#00450d] p-10 rounded-[32px] shadow-sm hover:shadow-lg transition-all flex flex-col gap-6"
                >
                  <div className="flex items-center gap-4">
                    <span className="text-2xl">{dept.icon}</span>
                    <h3 className="text-2xl font-bold text-[#171d14]">
                      {dept.title}
                    </h3>
                  </div>
                  <ul className="flex flex-col gap-4">
                    {dept.items.map((item, j) => (
                      <li
                        key={j}
                        className="flex gap-3 items-start text-[#41493e]"
                      >
                        <div className="mt-1.5 w-1.5 h-1.5 bg-[#00450d] rounded-full shrink-0"></div>
                        <span className="text-base leading-relaxed">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bento Grid Section */}
        <section className="bg-white py-24 px-6">
          <div className="max-w-[1536px] mx-auto flex flex-col gap-20">
            <div className="flex flex-col gap-6 text-center items-center">
              <h2 className="text-4xl md:text-[60px] font-extrabold text-[#00450d]  manrope">
                Purpose-Built Solutions
              </h2>
              <p className="text-[#41493e] text-xl">
                Ready-to-deploy agentic workflows for critical business
                bottlenecks.
              </p>
            </div>

            <div className="grid grid-cols-3 ipadMin:grid-cols-2 gap-6 md:h-[600px]">
              {/* <div className="grid grid-cols-3 mobile:grid-cols-1 gap-6"> */}
              <div className=" col-span-2 mobile:col-span-full ipadMin:col-span-1 bg-[#e9f0e1] rounded-[32px] p-8 relative overflow-hidden group min-h-[300px]">
                <div className="absolute inset-0 opacity-20 pointer-events-none">
                  <img
                    src={loanOriginationImg}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative z-10 h-full flex flex-col justify-end gap-4 max-w-lg">
                  <h3 className="text-3xl font-bold text-[#171d14]">
                    Loan Origination
                  </h3>
                  <p className="text-[#41493e] text-lg leading-relaxed">
                    Slash approval times from weeks to hours with automated
                    document verification and risk scoring.
                  </p>
                </div>
              </div>
              <div className=" col-span-1 mobile:col-span-full ipadMin:col-span-1 bg-[#00450d] rounded-[32px] p-8 flex flex-col justify-center gap-6 group">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                >
                  <path
                    d="M6 40C4.9 40 3.95833 39.6083 3.175 38.825C2.39167 38.0417 2 37.1 2 36V13.45C1.4 13.0833 0.916667 12.6083 0.55 12.025C0.183333 11.4417 0 10.7667 0 10V4C0 2.9 0.391667 1.95833 1.175 1.175C1.95833 0.391667 2.9 0 4 0H36C37.1 0 38.0417 0.391667 38.825 1.175C39.6083 1.95833 40 2.9 40 4V10C40 10.7667 39.8167 11.4417 39.45 12.025C39.0833 12.6083 38.6 13.0833 38 13.45V36C38 37.1 37.6083 38.0417 36.825 38.825C36.0417 39.6083 35.1 40 34 40H6ZM6 14V36H34V14H6ZM4 10H36V4H4V10ZM14 24H26V20H14V24Z"
                    fill="#F6E550"
                  />
                </svg>
                <h3 className="text-2xl font-bold text-white">
                  Inventory Management
                </h3>
                <p className="text-[#acf4a4] text-sm leading-relaxed">
                  Self-correcting supply chains that predict and resolve
                  stock-outs before they happen.
                </p>
                {/* </div> */}
              </div>
              {/* <div className="grid grid-cols-3 mobile:grid-cols-1 gap-6"> */}
              <div className="col-span-1 mobile:col-span-full ipadMin:col-span-1 bg-[#dee5d6] rounded-[32px] p-8 flex flex-col justify-between group min-h-[200px]">
                <div className="flex flex-col gap-4">
                  <h3 className="text-2xl font-bold text-[#171d14]">
                    Financial Crime Compliance
                  </h3>
                  <p className="text-[#41493e] text-sm leading-relaxed">
                    Real-time AML monitoring and SAR reporting with 99.9%
                    accuracy.
                  </p>
                </div>
                <button className="flex items-center gap-2 text-[#00450d] font-bold mt-4">
                  Learn More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </button>
              </div>

              <div className="col-span-1 mobile:col-span-full ipadMin:col-span-1 bg-[#f6e550] rounded-[32px] p-8 flex flex-col justify-between group min-h-[200px]">
                <div className="flex flex-col gap-4">
                  <h3 className="text-2xl font-bold text-[#1f1c00]">
                    Medical Record Summarization
                  </h3>
                  <p className="text-[#4f4800] text-sm leading-relaxed">
                    Extracting key clinical insights from thousands of pages in
                    seconds.
                  </p>
                </div>
                <div className="w-full bg-[#1f1c00]/10 h-1.5 rounded-full overflow-hidden mt-6">
                  <div className="bg-[#00450d] h-full w-[65%]"></div>
                </div>
              </div>

              <div className="col-span-1 mobile:col-span-full ipadMin:col-span-1 bg-[#eff6e7] rounded-[32px] p-8 relative overflow-hidden group min-h-[200px]">
                <div className="flex flex-col gap-2 relative z-10">
                  <h3 className="text-xl font-bold text-[#171d14]">
                    Merchandising
                  </h3>
                  <p className="text-[#41493e] text-sm leading-relaxed">
                    Dynamic shelf-space optimization and markdown strategy
                    automation.
                  </p>
                </div>
                <div className="absolute inset-0 bg-[#00450d]/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className="py-24 px-6 mb-20 bg-[#F5FCED]">
          <div className="max-w-[1024px] mx-auto bg-[#00450d] rounded-[48px] p-12 mobile:p-4 text-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_right,_#1b5e20,_transparent),_radial-gradient(circle_at_bottom_left,_#00450d,_transparent)]"></div>
            <div className="relative z-10 flex flex-col items-center gap-8">
              <h2 className="text-4xl md:text-[60px] font-extrabold text-white leading-[1.1] manrope">
                Ready to transform your <br /> enterprise?
              </h2>
              <p className="text-[#acf4a4] text-xl max-w-2xl leading-relaxed">
                Join 500+ global enterprises leveraging Teja Technologies to
                automate complexity and scale intelligence.
              </p>
              <button
                onClick={() => navigate("/contact-us")}
                className="bg-[#f6e550] text-[#1f1c00] px-12 py-5 rounded-full font-bold text-xl hover:bg-[#ffe500] transition-all transform hover:scale-105 mt-4"
              >
                Request Demo
              </button>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default AgenticSolutions;
